const cookies = [
  {
    key: 'hideCookieConsent',
    name: 'mk.hcc',
    provider: 'mymk.de',
    purpose: 'Speichert Sitzungsübergreifend ob die Cookie-Einstellungen angezeigt werden sollen.',
    validity: 'Unbegrenzt',
  },
  {
    key: 'acceptedCookieGroups',
    name: 'mk.acg',
    provider: 'mymk.de',
    purpose: 'Speichert Sitzungsübergreifend welchen Cookiegruppen zugestimmt wurde.',
    validity: 'Unbegrenzt',
  },
  {
    key: 'hcaptcha',
    name: 'session',
    provider: 'hcaptcha.com',
    purpose: 'Dient der Absicherung von Formularen gegen Spam und Missbrauch.',
    validity: 'Sitzung',
    blocked: 'Wir setzen HCaptcha ein um Spamanfragen zu verhindern. Damit Sie das Formular verwenden können, müssen Sie funktionale Cookies akzeptieren.',
  },
  {
    key: 'matomo',
    name: '–',
    provider: 'mymk.de',
    purpose: 'Wir verwenden Matomo zur anonymisierten Reichweitenmessung ohne den Einsatz von Cookies.',
    validity: 'Keine Speicherung im Browser',
  }
];

export default cookies;